import i18n from '@/i18n'
import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/vehicle-category'

export const get = async (queryParam) => {
  getFleetIcons()
  queryParam.filters = [`company_id eq 1`]
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  response.data.data?.paginated_result?.forEach((val) => {
    val['can_edit'] = false
    val['can_delete'] = true
  })

  response.data.data?.paginated_result.map(
    (x) => (x.icon = constants.data.iconOptions?.find((y) => y.value === x.icon))
  )

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: {
      ...data,
      company_id: 1,
    },
  })
  return response
}

export const constants = {
  data: {
    iconOptions: [],
  },
}

export const getFleetIcons = () => {
  constants.data.iconOptions = [
    {
      label: i18n.t('master.icon.bigTruck'),
      value: 'bigTruck',
      img: require('@/assets/images/vehicles/bigTruck/bigTruck-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.bus'),
      value: 'bus',
      img: require('@/assets/images/vehicles/bus/bus-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.car'),
      value: 'car',
      img: require('@/assets/images/vehicles/car/car-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.container'),
      value: 'container',
      img: require('@/assets/images/vehicles/container/container-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.electricCar'),
      value: 'electricCar',
      img: require('@/assets/images/vehicles/electricCar/electricCar-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.electricMotor'),
      value: 'electricMotorcycle',
      img: require('@/assets/images/vehicles/electricMotorcycle/electricMotorcycle-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.excavator'),
      value: 'excavator',
      img: require('@/assets/images/vehicles/excavator/excavator-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.motorcycle'),
      value: 'motorcycle',
      img: require('@/assets/images/vehicles/motorcycle/motorcycle-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.smallTruck'),
      value: 'smallTruck',
      img: require('@/assets/images/vehicles/smallTruck/smallTruck-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.van'),
      value: 'van',
      img: require('@/assets/images/vehicles/van/van-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.truckHead'),
      value: 'truckHead',
      img: require('@/assets/images/vehicles/truckHead/truckHead-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.tractor'),
      value: 'tractor',
      img: require('@/assets/images/vehicles/tractor/tractor-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.train'),
      value: 'train',
      img: require('@/assets/images/vehicles/train/train-blue.svg'),
      style: 'transform: rotate(270deg); width: 6px',
    },
    {
      label: i18n.t('master.icon.mixerTruck'),
      value: 'mixerTruck',
      img: require('@/assets/images/vehicles/mixerTruck/mixerTruck-blue.svg'),
      style: 'transform: rotate(270deg); width: 14px',
    },
    {
      label: i18n.t('master.icon.person'),
      value: 'person',
      img: require('@/assets/images/vehicles/person/person-blue.svg'),
      style: 'width: 14px',
    },
  ]
}
